import { Box } from '@mui/material';
import { Logo } from '@src/components/logo';
import { useSessionContext } from '@src/modules';
import { useTheme } from '@src/themes';
import { FC } from 'react';

const Header: FC = () => {
  const { COLORS } = useTheme();
  const { userLogged } = useSessionContext();

  if (userLogged === true) return <></>;

  return (
    <Box
      sx={{
        background: COLORS.primary.main,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingY: 2,
        borderRadius: '0 0 8px 8px',
      }}
    >
      <Logo width={130} />
    </Box>
  );
};

export { Header };
